import { render, staticRenderFns } from "./batchPassDialog.vue?vue&type=template&id=6c6f00b4&scoped=true"
import script from "./batchPassDialog.vue?vue&type=script&lang=js"
export * from "./batchPassDialog.vue?vue&type=script&lang=js"
import style0 from "./batchPassDialog.vue?vue&type=style&index=0&id=6c6f00b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6f00b4",
  null
  
)

export default component.exports